<template>
  <div>
    <template v-if="isShowOptions">
      <div class="customization-title">Choose template</div>
      <RadioGroup
        type="image"
        :group="id"
        :options="options"
        :loading="loading"
        v-model="templateIdSelected"
        class="mb-sm"
      ></RadioGroup>
    </template>
    <div
      v-for="(item, i) in uploadFormSelected"
      :key="i"
      class="custom-upload-image-face-swap"
    >
      <FaceSwapUpload
        v-bind="{
          id: `${id}-${i}`,
          inputFileCustomily,
          selectImageButtonCustomily,
          faceIndex: +item.index,
          title: item.title,
          imageDefault: imageDefaultSelected,
          optionSortId,
          templateIdSelected,
        }"
      ></FaceSwapUpload>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue'
import FaceSwapUpload from './FaceSwapUpload.vue'
import RadioGroup from '@/ui-kits/RadioGroup.vue'
import { EVENT_CUSTOM_UPLOAD_IMAGE } from '@/utils'
import EventBus from '@/services/eventbus'
import { useProductCustomization } from './composables/ProductCustomization'
import useCustomizationStore from '@/store/customization'

const { convertImageLinkToFileList, changeFileImageCustomily } =
  useProductCustomization()
const customizationStore = useCustomizationStore()

const props = withDefaults(
  defineProps<{
    id: string
    inputFileCustomily: Element
    selectImageButtonCustomily: Element
    optionSortId: string
    templates: {
      id?: any
      name?: string
      image: string
      upload_form: { title: string; index: number }[]
    }[]
  }>(),
  {}
)

const options = props.templates.map((option) => ({
  id: option.id,
  name: option.name || '',
  image: option.image,
  value: option.id,
  sources: [{ size: 100 }],
}))

const isShowOptions = computed(() => options.length > 1)

const loading = ref(false)
let templateIdSelected = ref(props.templates[0].id)
const uploadFormSelected = ref(props.templates[0].upload_form)
const imageDefaultSelected = ref(props.templates[0].image)

onMounted(() => {
  watch(
    () => templateIdSelected.value,
    async (value) => {
      const templates = props.templates
      if (!templates.length) return
      const index = templates.findIndex((item) => item.id == value)
      if (index == -1) {
        uploadFormSelected.value = templates[0].upload_form
        imageDefaultSelected.value = templates[0].image
      } else {
        uploadFormSelected.value = templates[index].upload_form
        imageDefaultSelected.value = templates[index].image
      }

      const indexfaceSwapped = customizationStore.faceSwapped.findIndex(
        (item) =>
          item.optionSortId == props.optionSortId && item.templateId == value
      )
      const sourceLink =
        indexfaceSwapped > -1
          ? customizationStore.faceSwapped[indexfaceSwapped].sourceLink
          : imageDefaultSelected.value
      const imageFileList = await convertImageLinkToFileList(
        sourceLink,
        'sib_image-faceswap'
      )
      changeFileImageCustomily(imageFileList, props.inputFileCustomily)
    }
  )
  EventBus.on(EVENT_CUSTOM_UPLOAD_IMAGE, (value) => (loading.value = value))
})
</script>

<style lang="scss">
.custom-upload-image-face-swap {
  display: block;
  margin-top: 1rem;
  .customization-upload-image-wrapper {
    display: inline;
  }
}
</style>
